import Collection from '../../../collection';
import Config from '../../../config';
import Grid from '../../grid';
import Stickers from '../../../collection/refbooks/stickers';
import View from "../../view";

import { hashify } from '../../../utils/arrays';
import { roleA } from '../../../roles';
import { filterAvailableStickers } from '../../../model/refbooks/field.utils';





export default View.extend( {

    // ???
    onBind(/*model*/) {
        this.options.sorted = new Stickers();
        this.options.filtered = new Stickers();
        this.options.resulted = new Stickers();

        // wait for sorting & filter (copy of subfields.grid)
        this.sorting_ = this.reSort().then( () => this.reFilterGrid() );
    },

    serialize() {
        // wait for current sorting & filter? (copy of subfields.grid)
        // sorting is fast, but it's async now;
        // so we must wait until sorting in onBind finishes
        return this.sorting_.then( () => 
            ({ 
                rows: this.options.resulted, 
                stickers: this.options.filtered
            }) );
x   },

    events: {
        
        // copy of subfields.grid
        'click .-sort'({currentTarget}) {
            const { sort, direction, } = currentTarget.dataset;

            return this.options.page = 1, this.options.sort = sort, this.options.direction = direction,
                this.reSort().then( () => this.reFilterGrid() )
                    // hack: reFilterGrid() to do filtering, then render() to re-render grid header
                    .then( () => this.render() )
                    .then( () => this.trigger( 'sort', { sort, direction } ) );
        },

        'click .-toggle-binding'({currentTarget}) {
            const { id } = currentTarget.dataset;
            const { filtered } = this.options;

            const needAppend = currentTarget.checked;
            const oldStickers = this.model.get( 'sticker_ids' ) || [];
            const newStickers = needAppend
                ? [...oldStickers, id]
                : oldStickers.filter( itemId => itemId != id );

            this.model.set( 'sticker_ids', newStickers );

            const ids = hashify( newStickers );
            this.$( '.-toggle-all' )[0].checked = 
                // contains ids of stickers that can be checked/unchecked by current user
                this.getAvailableFilteredStickerIds( filtered ).every( stickerId => ids[stickerId] );
        },

        'click .-toggle-all'({currentTarget}) {
            // contains ids of stickers that can be checked/unchecked by current user
            const ids = this.getAvailableFilteredStickerIds( this.options.filtered );

            const h = hashify( ids );
            const drained = (this.model.get( 'sticker_ids' ) || [])
                .filter( id => !h[id] )

            const value = currentTarget.checked;
            this.model.set( 'sticker_ids', value
                ? [...drained, ...ids]
                : [...drained] );

            const values = hashify( this.model.get( 'sticker_ids' ) );
            this.$( '.-toggle-binding' ).toArray()
                .forEach( el => el.checked = !!values[el.dataset.id] )
        },

        'click .-toggle-all-stickers-available'({currentTarget}) {
            if (!currentTarget.checked)
                if (this.model.get( 'sticker_ids' ) == null)
                    this.model.set( 'sticker_ids', [] );
                else
                    // hack: undefined instead of false to make no diff with default value
                    this.model.set( '__all_stickers_available', undefined );
            else
                this.model.set( '__all_stickers_available', true );

            if (this.model.get( 'sticker_ids' ) == null || this.model.get( '__all_stickers_available' )) 
                this.$( '.stickers-grid--disability-wrapper').addClass( 'disabled' );
            else
                this.$( '.stickers-grid--disability-wrapper').removeClass( 'disabled' );
        }

    },

    [View.event( 'Paging:page')](page) {
        return this.options.page = page, 
            this.reFilterGrid(),
            this.trigger( 'page', page );
    },

    [View.event( 'Search:search')](search) {
        return this.options.search = search, this.options.page = 1,
            this.reFilterGrid(),
            this.trigger( 'search', search );
    },

    reSort(sort, direction) {
        sort = sort || this.options.sort;
        direction = direction || this.options.direction;

        return Grid.sort( { sort, direction }, 
            this.options.stickers, this.options.sorted );
    },
    
    reFilterGrid() {
        const availableStickers = filterAvailableStickers( 
            this.options.types,
            this.model,
            this.options.sorted );

        const { search, filtered, resulted, page, limit } 
            = this.options;

        Grid.filter( { search, page, limit }, 
            this.model.get( 'cluster' ),
            availableStickers, filtered, resulted );
    },

    getAvailableFilteredStickerIds(stickerCollection) {
        const models = stickerCollection instanceof Collection
            ? stickerCollection.models
            : stickerCollection;
    
        return models
            // ignore unavailable (disabled) checkboxes
            .filter( sticker => 
                // chief admin may check any sticker
                // (local stickers of wrong cluster do not pass filtration)
                roleA.includes( Config.role() ) ||
                // local stickers may be checked anyway
                // (local stickers of wrong cluster do not pass filtration)
                sticker.get( 'cluster' ) ||
                // local sticker may be joined to any field
                // (local stickers of wrong cluster do not pass filtration)
                this.model.get( 'cluster' ) )
            .map( type => type.id );
    }
    
} ); 


// WEBPACK FOOTER //
// ./src/js/view/module/refbooks/fields.form.stickers.grid.js